'use strict';
import * as $j_app$002edata$002e$002dOperational$002dApp$002dRegistered$002dUser$0024$002dAdmin from "./app.data.-Operational-App-Registered-User$-Admin.js";
import * as $j_app$002edata$002eauth$0024package$0024$002dIs$002dUser$002dAdmin$0024 from "./app.data.auth$package$-Is-User-Admin$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_OperationalAppRegisteredUser$Admin$() {
}
export { $c_Lapp_data_OperationalAppRegisteredUser$Admin$ as $c_Lapp_data_OperationalAppRegisteredUser$Admin$ };
$c_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype.constructor = $c_Lapp_data_OperationalAppRegisteredUser$Admin$;
/** @constructor */
function $h_Lapp_data_OperationalAppRegisteredUser$Admin$() {
}
export { $h_Lapp_data_OperationalAppRegisteredUser$Admin$ as $h_Lapp_data_OperationalAppRegisteredUser$Admin$ };
$h_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype = $c_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype;
$c_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype.apply__Lapp_data_OperationalAppRegisteredUser__s_Option = (function(user) {
  if ((!(!$j_app$002edata$002eauth$0024package$0024$002dIs$002dUser$002dAdmin$0024.$m_Lapp_data_auth$package$IsUserAdmin$().given_Conversion_Type_Boolean__s_Conversion().apply__O__O(user.server__Lapp_data_AppRegisteredUser().isAdmin__Z())))) {
    var value = new $j_app$002edata$002e$002dOperational$002dApp$002dRegistered$002dUser$0024$002dAdmin.$c_Lapp_data_OperationalAppRegisteredUser$Admin(user);
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
  } else {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype.fromProduct__s_Product__Lapp_data_OperationalAppRegisteredUser$Admin = (function(x$0) {
  var user$1 = x$0.productElement__I__O(0);
  return new $j_app$002edata$002e$002dOperational$002dApp$002dRegistered$002dUser$0024$002dAdmin.$c_Lapp_data_OperationalAppRegisteredUser$Admin(user$1);
});
$c_Lapp_data_OperationalAppRegisteredUser$Admin$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_OperationalAppRegisteredUser$Admin(p);
});
var $d_Lapp_data_OperationalAppRegisteredUser$Admin$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_OperationalAppRegisteredUser$Admin$, "app.data.OperationalAppRegisteredUser$Admin$", ({
  Lapp_data_OperationalAppRegisteredUser$Admin$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_OperationalAppRegisteredUser$Admin$ as $d_Lapp_data_OperationalAppRegisteredUser$Admin$ };
var $n_Lapp_data_OperationalAppRegisteredUser$Admin$;
function $m_Lapp_data_OperationalAppRegisteredUser$Admin$() {
  if ((!$n_Lapp_data_OperationalAppRegisteredUser$Admin$)) {
    $n_Lapp_data_OperationalAppRegisteredUser$Admin$ = new $c_Lapp_data_OperationalAppRegisteredUser$Admin$();
  }
  return $n_Lapp_data_OperationalAppRegisteredUser$Admin$;
}
export { $m_Lapp_data_OperationalAppRegisteredUser$Admin$ as $m_Lapp_data_OperationalAppRegisteredUser$Admin$ };
//# sourceMappingURL=app.data.-Operational-App-Registered-User$-Admin$.js.map
